import 'angular:locale/data:ko';
import './apps/sbe-staff-web/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "ko";
